import { request } from 'src/api/request';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';

export const getPacAffiliations = async ({
  pacId,
  queryParams,
}: {
  pacId: string;
  queryParams: string;
}) => {
  if (!pacId) return;
  return await request({
    url: `v1/entities/hcp-group/${pacId}/affiliations/${queryParams}`,
    method: 'GET',
  });
};

export const getPacAffiliationsV2 = async ({ pacId, queryParams, data }) => {
  if (!pacId) return;
  return await request({
    url: `v1/entities/v2/hcp-group/${pacId}/affiliations/${queryParams}`,
    method: 'POST',
    data,
    // Idempotent ES read (params in the body) — opt into the 503 retry.
    retryOn503: true,
  });
};

export const getExport = async ({
  pacId,
  queryParams,
  fileType,
  fileName,
  columns,
}: {
  pacId: string;
  queryParams: any;
  fileType: string;
  fileName: string;
  columns: string[];
}) => {
  const newQueryParams = getSearchQueryParamsForAPI({
    ...queryParams,
  });

  const url = `https://api.medscout.io/api/v1/entities/hcp-group/${pacId}/affiliations?${newQueryParams}/`;
  return request({
    url: '/v1/admin/export/',
    method: 'POST',
    data: {
      url,
      file_format: fileType,
      fileName,
      columns: columns,
    },
  });
};
